import * as R from 'ramda';

type CheckValue = (v: any) => boolean;

export const isNotNil: CheckValue = R.complement(R.isNil);
export const isNotEmpty: CheckValue = R.complement(R.isEmpty);
export const hasValue: CheckValue = R.allPass([isNotEmpty, isNotNil]);
export const hasNoValue: CheckValue = R.complement(hasValue);

export const isTrue: CheckValue = R.equals(true);
export const isFalse: CheckValue = R.complement(isTrue);
